import { AnyAction } from 'redux'
import { sendDataLayerEvent } from '../../datalayer'

export interface PaymentPageLoadProps {
  journey: {
    id: string
    name: string
    stepNumber: string
    stepName: string
  }
  vehicle: Cinch.OrderDetailsVehicle
  partEx?: Cinch.OrderDetailsPartExVehicle
}

export interface PaymentsPageLoadActionProps extends AnyAction {
  payload: PaymentPageLoadProps
}

export const paymentMethodsLoadEvent = (action: PaymentsPageLoadActionProps) => {
  sendDataLayerEvent({
    journey: action.payload.journey,
    product: [
      {
        vehicle: action.payload.vehicle,
        part_ex: action.payload.partEx,
      },
    ],
  })
}
